import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';

function Blog() {
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);

  const tweets = [
    { id: 1, content: "التطوير التنظيمي يبدأ من فهم احتياجات الأفراد.", date: "22 مارس 2025" },
    { id: 2, content: "التواصل الاستراتيجي هو جسر النجاح.", date: "21 مارس 2025" },
    { id: 3, content: "بناء القدرات البشرية استثمار طويل الأمد.", date: "20 مارس 2025" },
    { id: 4, content: "الإعلام المسؤول يصنع فرقًا.", date: "19 مارس 2025" },
    { id: 5, content: "التغيير يبدأ من القيادة.", date: "18 مارس 2025" },
  ];

  const articles = [
    {
      id: 1,
      title: "أهمية التواصل الاستراتيجي",
      content: "كيف يمكن للتواصل أن يغير ديناميكيات العمل في المؤسسات.",
      date: "17 مارس 2025",
      fullContent: "التواصل الاستراتيجي هو العمود الفقري لنجاح أي مؤسسة. من خلال صياغة رسائل واضحة وموجهة، يمكن للمؤسسات تحسين تفاعلها مع الجمهور الداخلي والخارجي، مما يعزز الكفاءة ويحقق الأهداف بشكل أسرع."
    },
    {
      id: 2,
      title: "بناء فرق عمل قوية",
      content: "استراتيجيات لتعزيز الأداء الجماعي وتحقيق الأهداف.",
      date: "16 مارس 2025",
      fullContent: "بناء فرق عمل قوية يتطلب التركيز على الثقة والتواصل المفتوح. الاستراتيجيات مثل التدريب المستمر وتحديد الأدوار بوضوح تساعد في تعزيز التعاون ورفع الأداء."
    },
    {
      id: 3,
      title: "التطوير التنظيمي 2025",
      content: "رؤية مستقبلية لتحسين أداء المؤسسات في العصر الرقمي.",
      date: "15 مارس 2025",
      fullContent: "مع تقدم التكنولوجيا، يصبح التطوير التنظيمي أكثر تعقيدًا وأهمية. الرؤية لعام 2025 تركز على دمج الأدوات الرقمية لتحسين الهياكل التنظيمية وزيادة المرونة."
    },
    {
      id: 4,
      title: "دور الإعلام في التغيير",
      content: "كيف يمكن للإعلام أن يكون أداة للتأثير الإيجابي.",
      date: "14 مارس 2025",
      fullContent: "الإعلام ليس مجرد وسيلة لنقل الأخبار، بل أداة قوية للتأثير على المجتمع. من خلال تقديم محتوى هادف، يمكن للإعلام أن يحفز التغيير الإيجابي ويعزز الوعي."
    },
    {
      id: 5,
      title: "تطوير الموارد البشرية",
      content: "أساليب حديثة لرفع كفاءة الموظفين.",
      date: "13 مارس 2025",
      fullContent: "تطوير الموارد البشرية يعتمد على أساليب مثل التدريب التفاعلي والتقييم المستمر. هذه الأساليب تساعد في رفع كفاءة الموظفين ومواكبة متطلبات السوق."
    },
  ];

  const handleShowModal = (article) => {
    setSelectedArticle(article);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedArticle(null);
  };

  return (
    <div className="blog-page">
      <Container className="py-5 position-relative page-content">
        <h2 className="text-center mb-5 page-title aref-ruqaa">المدونة</h2>
        <Row>
          <Col md={6}>
            <div className="text-bg-blur">
              <h3 className="mb-4">التغريدات</h3>
              {tweets.map((tweet) => (
                <Card key={tweet.id} className="mb-3 blog-card shadow-lg">
                  <Card.Body>
                    <Card.Text>{tweet.content}</Card.Text>
                    <Card.Footer className="text-muted">{tweet.date}</Card.Footer>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <div className="text-bg-blur">
              <h3 className="mb-4">الأخبار والمقالات</h3>
              {articles.map((article) => (
                <Card key={article.id} className="mb-3 blog-card shadow-lg">
                  <Card.Body>
                    <Card.Title>{article.title}</Card.Title>
                    <Card.Text>{article.content}</Card.Text>
                    <Card.Footer className="text-muted">{article.date}</Card.Footer>
                    <Button
                      variant="outline-light"
                      size="sm"
                      onClick={() => handleShowModal(article)}
                    >
                      اقرأ المزيد
                    </Button>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
        </Row>

        {/* Modal for Full Article */}
        {selectedArticle && (
          <Modal
            show={showModal}
            onHide={handleCloseModal}
            centered
            dir="rtl"
            className="custom-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>{selectedArticle.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{selectedArticle.fullContent}</p>
              <p className="text-muted">{selectedArticle.date}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-light" onClick={handleCloseModal}>
                إغلاق
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
    </div>
  );
}

export default Blog;